import bugsnag from 'bugsnag-js';
import config from '../../bugsnag.config.json';

export const SET_BUGSNAG_USER = 'SET_BUGSNAG_USER';
export const CLEAR_BUGSNAG_USER = 'CLEAR_BUGSNAG_USER';

const Bugsnag = bugsnag( config );

const initialState = {
  Bugsnag,
};

export default function reducer( state = initialState, action ) {
  let newstate = state;
  switch( action.type ) {
  case SET_BUGSNAG_USER: {
    newstate.Bugsnag.user = action.payload;
    state = { ...newstate };
    break;
  }
  case CLEAR_BUGSNAG_USER: {
    newstate.Bugsnag.user = action.payload;
    state = { ...newstate };
    break;
  }
  default:
    return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/bugsnag.js